/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Runs_View_AllInputs */

const en_automation_runs_view_all = /** @type {(inputs: Automation_Runs_View_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View runs`)
};

const pt_br2_automation_runs_view_all = /** @type {(inputs: Automation_Runs_View_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver execuções`)
};

/**
* | output |
* | --- |
* | "View runs" |
*
* @param {Automation_Runs_View_AllInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const automation_runs_view_all = /** @type {((inputs?: Automation_Runs_View_AllInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Runs_View_AllInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_runs_view_all(inputs)
	return pt_br2_automation_runs_view_all(inputs)
});